import { render } from "./usermanagement.vue?vue&type=template&id=566c6a7e&scoped=true"
import script from "./usermanagement.vue?vue&type=script&lang=js"
export * from "./usermanagement.vue?vue&type=script&lang=js"

import "./usermanagement.vue?vue&type=style&index=0&id=566c6a7e&scoped=true&lang=css"

import exportComponent from "/Users/tommygrimm/PhpstormProjects/hauptportal.20north.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566c6a7e"]])

export default __exports__